import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Dr. Sarah Mitchell',
      practice: 'Mitchell Family Practice',
      specialty: 'Family Medicine',
      quote: 'Bill Well Benefits increased our collections by 12% in the first three months. Their team is responsive, professional, and truly understands family practice billing.',
      rating: 5,
    },
    {
      name: 'Michael Chen, Practice Manager',
      practice: 'Cardiology Associates of Atlanta',
      specialty: 'Cardiology',
      quote: 'The real-time dashboard gives us complete visibility into our revenue cycle. Denials dropped from 15% to under 3%. Best decision we made for our practice.',
      rating: 5,
    },
    {
      name: 'Dr. Jennifer Lopez',
      practice: 'Serenity Mental Health',
      specialty: 'Behavioral Health',
      quote: 'Mental health billing is complex, but their certified coders know the nuances. We finally have a billing partner who gets it right the first time.',
      rating: 5,
    },
  ];

  return (
    <section className="py-32 bg-gradient-to-br from-slate-50 to-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <div className="text-[#14b8a6] font-semibold text-sm tracking-wider uppercase mb-4">
            Client Success Stories
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
            Loved by Healthcare Providers
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Don't just take our word for it—see what our partners have to say
            about their experience.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ delay: index * 0.15, duration: 0.6 }}
              whileHover={{ y: -10 }}
            >
              <Card className="h-full border-2 border-slate-100 hover:border-[#14b8a6]/30 transition-all duration-300 hover:shadow-xl relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-32 h-32 bg-[#14b8a6]/5 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500" />
                <CardContent className="p-8 relative z-10">
                  <Quote className="text-[#14b8a6] mb-6" size={40} />
                  
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        size={20}
                        className="fill-[#14b8a6] text-[#14b8a6]"
                      />
                    ))}
                  </div>

                  <p className="text-slate-700 leading-relaxed mb-6 text-lg">
                    "{testimonial.quote}"
                  </p>

                  <div className="border-t border-slate-100 pt-6">
                    <div className="font-bold text-slate-900">
                      {testimonial.name}
                    </div>
                    <div className="text-slate-600 text-sm">
                      {testimonial.practice}
                    </div>
                    <div className="text-[#14b8a6] text-sm font-medium mt-1">
                      {testimonial.specialty}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
